export const LOCATION_TYPE_PICKUP = "pickup";
export const LOCATION_TYPE_REFILL = "refill";
